module.exports = __webpack_public_path__ + "static/media/19_B.6fe43501.png";